export default __webpack_public_path__ + "img/apple-touch-icon.8edad84e.png";